import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { API } from '../App';
import { toast } from 'sonner';
import AdminUsers from '../components/AdminUsers';
import AdminEntries from '../components/AdminEntries';
import AdminSMTP from '../components/AdminSMTP';
import AdminBusinessSettings from '../components/AdminBusinessSettings';
import AdminAppointments from '../components/AdminAppointments';
import AdminCustomers from '../components/AdminCustomers';
import AdminAvailability from '../components/AdminAvailability';

export default function AdminDashboard() {
  const [view, setView] = useState('users');
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem('user') || '{}');

  useEffect(() => {
    // Check if user is admin
    if (!user.is_admin) {
      toast.error('Access denied: Admin only');
      navigate('/');
      return;
    }
    setLoading(false);
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    navigate('/login');
  };

  if (loading) return null;

  return (
    <div className="min-h-screen p-4 md:p-8" style={{ background: '#000000' }}>
      {/* Header */}
      <div className="retro-panel mb-6">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
          <div>
            <h1 className="text-4xl md:text-5xl font-bold glow-text" style={{ color: '#FF6B00', fontFamily: 'Orbitron, sans-serif' }}>
              ADMIN PANEL
            </h1>
            <div className="text-lg mt-1" style={{ color: '#ffffff' }}>
              USER: {user.username} | ROLE: <span style={{ color: '#FF6B00' }}>ADMINISTRATOR</span>
            </div>
          </div>
          <div className="flex gap-2">
            <button
              onClick={() => navigate('/')}
              data-testid="back-to-dashboard-button"
              className="retro-btn retro-btn-green"
            >
              [MAIN DASHBOARD]
            </button>
            <button
              onClick={handleLogout}
              data-testid="admin-logout-button"
              className="retro-btn retro-btn-magenta"
            >
              [LOGOUT]
            </button>
          </div>
        </div>
      </div>

      {/* View Toggle */}
      <div className="retro-panel mb-6">
        <div className="flex flex-wrap gap-4">
          <button
            onClick={() => setView('users')}
            data-testid="view-users-button"
            className={`retro-btn ${view === 'users' ? 'retro-btn-green' : ''}`}
          >
            [MANAGE USERS]
          </button>
          <button
            onClick={() => setView('appointments')}
            data-testid="view-appointments-button"
            className={`retro-btn ${view === 'appointments' ? 'retro-btn-green' : ''}`}
          >
            [JOB APPOINTMENTS]
          </button>
          <button
            onClick={() => setView('customers')}
            data-testid="view-customers-button"
            className={`retro-btn ${view === 'customers' ? 'retro-btn-green' : ''}`}
          >
            [CUSTOMERS]
          </button>
          <button onClick={() => navigate('/warranties')} data-testid="admin-warranties-button" className="retro-btn">[WARRANTIES]</button>
          <button
            onClick={() => setView('availability')}
            data-testid="admin-availability-button"
            className={`retro-btn ${view === 'availability' ? 'retro-btn-green' : ''}`}
          >
            [AVAILABILITY]
          </button>
          <button
            onClick={() => setView('entries')}
            data-testid="view-all-entries-button"
            className={`retro-btn ${view === 'entries' ? 'retro-btn-green' : ''}`}
          >
            [MANAGE ALL ENTRIES]
          </button>
          <button
            onClick={() => setView('business')}
            data-testid="view-business-button"
            className={`retro-btn ${view === 'business' ? 'retro-btn-green' : ''}`}
          >
            [BUSINESS SETTINGS]
          </button>
          <button
            onClick={() => setView('smtp')}
            data-testid="view-smtp-button"
            className={`retro-btn ${view === 'smtp' ? 'retro-btn-green' : ''}`}
          >
            [SMTP CONFIG]
          </button>
        </div>
      </div>

      {/* Content */}
      {view === 'users' && <AdminUsers />}
      {view === 'appointments' && <AdminAppointments />}
      {view === 'customers' && <AdminCustomers />}
      {view === 'availability' && <AdminAvailability />}
      {view === 'entries' && <AdminEntries />}
      {view === 'business' && <AdminBusinessSettings />}
      {view === 'smtp' && <AdminSMTP />}
    </div>
  );
}